// EL TÍTULO DE UNA CARD NO ES UNA ETIQUETA DE DATO
//
// Las cards de esta pantalla venían todas con el mismo tratamiento:
// MAYÚSCULA SOSTENIDA, gris claro, 12px. Eso es el formato de un rótulo de
// dato ("TASA", "ACUMULADO") — cuatro palabras y funciona; ocho palabras
// ("TASA DE CANCELACION DIARIA") y hay que deletrearlo para leerlo.
//
// El título de una card se lee como un título: capitalización normal y color
// fuerte, igual que los titulares de los bloques nuevos (ver Stats2/theme.js,
// UI.texto). Los rótulos cortos de dato SÍ se quedan en mayúscula: ahí la
// mayúscula separa el rótulo del número, que es justo lo que tiene que hacer.

/** Título de card. Capitalización normal, color fuerte. */
export const TITULO_CARD = {
  fontSize: 14,
  fontWeight: 700,
  color: "#1f2937",
  letterSpacing: 0,
  textTransform: "none",
};

/** Aclaración al lado del título (el rango, el origen, la cantidad de días). */
export const TITULO_ACLARACION = {
  fontSize: 11.5,
  fontWeight: 400,
  color: "#6b7280",
  letterSpacing: 0,
  textTransform: "none",
};
